<template>
  <div class="setting-wrap w-940">
    <div class="wrap-title">アカウント情報</div>

    <el-form :model="member_info" :rules="rules" ref="userdata" style="width:100%" @submit.native.prevent="saveMember()">
      <div class="setting-subwrap top">
        <div class="setting-subtitle">プロフィール写真</div>
        <el-tooltip content="画像を変更" placement="right">
          <div class="list-breadcrumb-image" style="margin-bottom: 10px" @click="img_change = true">
            <div class="list-breadcrumb-icon">
              <font-awesome-icon :icon="['fas', 'camera-alt']" />
            </div>
            <el-image :src="member_info.img_url" class="data-table-profile list_img" fit="cover">
              <div slot="error" class="data-table-list-noimg">
                <font-awesome-icon :icon="['fas', 'building']" style="font-size: 20px" />
              </div>
            </el-image>
          </div>
        </el-tooltip>
      </div>
      <div class="setting-subwrap">
        <div class="setting-subtitle">名前</div>
        <el-form-item class="setting-form" prop="person_name">
          <el-input size="small" v-model="member_info.person_name"></el-input>
        </el-form-item>
      </div>
      <div class="setting-subwrap">
        <div class="setting-subtitle">部署・役職</div>
        <el-form-item class="setting-form" prop="position">
          <el-input size="small" v-model="member_info.position"></el-input>
        </el-form-item>
      </div>
      <div class="divider-nomargin"></div>
      <el-button type="primary" size="small" native-type="submit" :disabled="loading">
        <div class="flex-row">
          変更を保存
          <div class="loader--mini" v-show="loading"></div>
        </div>
      </el-button>
    </el-form>

    <el-dialog title="イメージ画像の変更" :visible.sync="img_change" width="420px" top="20vh">
      <el-upload drag :on-change="imgAdd" :auto-upload="false" list-type="picture" :limit="1" :file-list="fileList">
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">
          画像をドロップ
          <em>もしくは選択してアップロードしてください</em>
        </div>
        <div class="el-upload__tip" slot="tip">推奨ファイル:500kb以下のjpg/png形式</div>
      </el-upload>
      <span slot="footer" class="dialog-footer">
        <el-button @click="(img_change = false), (fileList = [])">キャンセル</el-button>
        <el-button type="primary" @click="ImgUpload()" :disabled="file == ''">
          <div class="flex-row">
            変更
            <div class="loader--mini" v-show="img_loading"></div>
          </div>
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { handleApiResponse, ERROR_MESSAGES } from "@/components/common/responseHelper";
import { getImageUploadWarning } from "@/components/common/imageUploadHelper";
const root = process.env.VUE_APP_API;
const saveMemberAPI = root + "/api/member/save_member";
const ImgUploadAPI = root + "/api/auth/img_upload";

export default {
  name: "accountInfo",
  props: ["member_info"],
  data() {
    return {
      loading: false,
      img_loading: false,
      img_change: false,
      file: "",
      fileList: [],
      rules: {
        person_name: [{ required: true, message: "名前は必須です", trigger: "blur" }],
        position: [{ required: true, message: "部署・役職は必須です", trigger: "blur" }],
      },
    };
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    user_token() {
      return this.$store.state.user_token;
    },
  },
  mounted() {},
  methods: {
    saveMember() {
      this.$refs["userdata"].validate((valid) => {
        if (valid) {
          this.loading = true;
          var params = new URLSearchParams();
          params.append("token", this.token);
          params.append("type", "account");
          params.append("member", JSON.stringify(this.member_info));
          params.append("person_id", this.member_info.person_id);
          this.axios
            .post(saveMemberAPI, params)
            .then(() => {
              this.$emit("loadMember");
              this.loading = false;
              this.$store.dispatch("getUserData", { token: this.token, user_token: this.user_token });
              this.$message({
                type: "success",
                offset: 7,
                showClose: true,
                message: "アカウント情報を変更しました",
              });
            })
            .catch(() => {
              this.load = false;
            });
        } else {
          this.$message({
            type: "error",
            offset: 7,
            showClose: true,
            message: "全ての項目を入力してください",
          });
          this.loading = false;
        }
      });
    },
    imgAdd(file, fileList) {
      const result = getImageUploadWarning(file);
      if (result.message) {
        this.$message({
          type: result.allowUpload ? "warning" : "error",
          offset: 7,
          showClose: true,
          message: result.message,
        });
      }
      if (!result.allowUpload) {
        this.file = "";
        this.fileList = [];
        return;
      }
      this.file = file;
      this.fileList = fileList;
    },
    ImgUpload() {
      if (!this.file || !this.file.raw) {
        return;
      }
      this.img_loading = true;
      var formData = new FormData();
      formData.append("file", this.file.raw);
      var config = {
        headers: {
          "content-type": "multipart/form-data",
        },
      };
      formData.append("type", "member");
      formData.append("person_id", this.member_info.person_id);
      formData.append("token", this.token);
      this.axios
        .post(ImgUploadAPI, formData, config)
        .then((response) => {
          if (handleApiResponse(response)) {
            this.$message({
              message: ERROR_MESSAGES.IMAGE_UPLOAD,
              type: "error",
            });
            return;
          }
          this.member_info.img_url = response.data.img_url;
          this.file = "";
          this.fileList = [];
          this.img_change = false;
          this.$message({
            type: "success",
            offset: 7,
            showClose: true,
            message: "イメージを変更しました",
          });
        })
        .catch(() => {
          this.$message({
            message: ERROR_MESSAGES.IMAGE_UPLOAD,
            type: "error",
          });
        })
        .finally(() => {
          this.img_loading = false;
        });
    },
  },
  watch: {},
  filters: {},
};
</script>
